// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2579":"6976b3d7","3837":"452815a6","3935":"53784661","4242":"090e215b","5431":"7c62a987","6192":"8fcf698a","7132":"f2bfe267","7520":"6976b3d7","8742":"7b8b1b52"}[chunkId] + ".chunk.css";
};